import { css } from 'lit';
export const bigFloatInputStyle = css `
  .input {
    height: 100%;
    width: 100%;
    padding: 0;
    color: var(--color-content-content-primary);
    box-sizing: border-box;
    border: none;
    background-color: transparent;
    outline: none;
    user-select: none;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    text-align: inherit;
  }
`;
//# sourceMappingURL=big-float-input.style.js.map